import { GlassLink } from '@components/glass/GlassButton';
import { Page } from '@components/ui/Page';
import { Section } from '@components/ui/Section';
import { CtaPanel } from '@features/cta/CtaPanel';
import { Hero } from '@features/home/Hero';
import { ProcessSteps } from '@features/process/ProcessSteps';
import { ServicesGrid } from '@features/services/ServicesGrid';
import { StackShowcase } from '@features/stack/StackShowcase';
import { WorkGrid } from '@features/work/WorkGrid';

import styles from './pages.module.scss';

/** How many projects the home page previews before linking to /work. */
const WORK_PREVIEW_COUNT = 3;

/**
 * The landing page, in the order a visitor's questions arrive: what do you
 * do, with what, have you done it before, how would it work with us.
 */
export const HomePage = () => (
  <Page>
    <Hero />

    <Section
      eyebrow="What we do"
      title="End-to-end engineering, one accountable team"
      lede="From the first prototype to the system that runs at scale, the same people design, build and operate it."
    >
      <ServicesGrid />
    </Section>

    <Section
      eyebrow="Selected work"
      title="Software built to do a job"
      lede="The kinds of systems we design, build and keep running."
    >
      <WorkGrid limit={WORK_PREVIEW_COUNT} />
      <div className={styles.more}>
        <GlassLink to="/work" icon="arrowRight">
          All work
        </GlassLink>
      </div>
    </Section>

    <Section eyebrow="The stack" title="Chosen for the problem, not the trend">
      <StackShowcase />
    </Section>

    <Section eyebrow="How we work" title="Four steps, no surprises">
      <ProcessSteps />
    </Section>

    <CtaPanel />
  </Page>
);
